import * as React from "react";

import { style, MyIconProps } from "./MyIcons";

export const DocumentContent = (props: MyIconProps): React.ReactElement => {
  return (
    <svg
      ref={props.elementRef}
      className={props.className}
      style={{ ...style(props), ...props.style }}
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    >
      <path d="M10 19H4.7C3.761 19 3 18.204 3 17.222V4.778C3 3.796 3.761 3 4.7 3H18.3C19.239 3 20 3.796 20 4.778V9" />
      <path d="M9 7H15" />
      <path d="M7 11H15" />
      <path d="M7 15H10" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.293 20.707L21.707 16.293C22.098 15.902 22.098 15.269 21.707 14.879L20.121 13.293C19.73 12.902 19.097 12.902 18.707 13.293L14.293 17.707C14.105 17.895 14 18.149 14 18.414V21H16.586C16.851 21 17.105 20.895 17.293 20.707V20.707Z"
      />
    </svg>
  );
};
